import Cookies from 'js-cookie'
import localStorageTool from '@/utils/localStorage'
import settings from '@/settings';
const useAppStore = defineStore(
  'app',
  {
    state: () => ({
      sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false,
        hide: false
      },
      device: 'desktop',
      size: localStorageTool.get('size') || 'default',
      lang: localStorageTool.get('APP_LANG') || settings.LANG
    }),
    actions: {
      toggleSideBar(withoutAnimation) {
        if (this.sidebar.hide) {
          return false;
        }
        this.sidebar.opened = !this.sidebar.opened
        this.sidebar.withoutAnimation = withoutAnimation
        if (this.sidebar.opened) {
          Cookies.set('sidebarStatus', 1)
        } else {
          Cookies.set('sidebarStatus', 0)
        }
      },
      closeSideBar({ withoutAnimation }) {
        Cookies.set('sidebarStatus', 0)
        this.sidebar.opened = false
        this.sidebar.withoutAnimation = withoutAnimation
      },
      toggleDevice(device) {
        this.device = device
      },
      setSize(size) {
        this.size = size;
        localStorageTool.set('size', size)
      },
      toggleSideBarHide(status) {
        this.sidebar.hide = status
      },
      setLang(lang) {
        this.lang = lang
        localStorageTool.set('APP_LANG', lang)
      }
    }
  })

export default useAppStore
